module.exports = __webpack_public_path__ + "img/rec_5.78f9f955.png";